import React, { memo, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { Button, rem } from 'design-system';
import StarRating from 'design-system/StarRating';
import useColors from 'hooks/useColors';
const RateModal = ({ onSubmit }) => {
    const [starCount, setStarCount] = useState(0);
    const onPressSubmit = () => {
        if (!starCount)
            return;
        onSubmit(starCount);
    };
    const onStarRatingPress = (rating) => {
        setStarCount(rating);
    };
    const colors = useColors();
    return (<View>
      <StarRating maxStars={5} emptyColor={colors.elements.secondaryLight} color={colors.gradients.yellow.colors[0]} rating={starCount} onChange={onStarRatingPress} starSize={40} style={styles.stars}/>
      <Button brand onPress={onPressSubmit} title="Submit"/>
    </View>);
};
const styles = StyleSheet.create({
    stars: {
        marginTop: rem(32),
        marginBottom: rem(40),
        alignSelf: 'center',
    },
});
export default memo(RateModal);
